// 引入el组件，有些自定义组件也在这里引入，不过基本上都没使用了
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import BreadCrumb from '../components/BreadCrumb'
import EChart from '../components/eChart'
import EntityInput from '../components/entity/EntityInput'
import defineTable from '../components/table/defineTable'
import defineColumn from '../components/table/defineColumn'
import defaultInput from '../components/defaultInput'
import defineInput from '../components/defineInput'
import platformInput from '../components/platformInput'
import QuarterSelect from '../components/quarterSelect/QuarterSelect'
import MDinput from '../components/MDinput'

Vue.use(ElementUI)
// Vue.component('BreadCrumb', BreadCrumb)
Vue.component('EChart', EChart)
Vue.component('QuarterSelect', QuarterSelect)
Vue.component('mdInput', MDinput)
Vue.component('EntityInput', EntityInput)
Vue.component('defineTable', defineTable)
Vue.component('defineColumn', defineColumn)
Vue.component('defineInput', defineInput)
Vue.component('defaultInput', defaultInput)
Vue.component('platformInput', platformInput)
